import { createErrorMatcher } from '@shared/lib/http-error';

const isUserAlreadyExistError = createErrorMatcher('UsernameExistsException');

export { isUserAlreadyExistError };
